import { DEFAULT_SERVICE_TICKET_STATUS_KEYS, type ServiceTicketStatusDef } from '@common/types';

export const SERVICE_TICKET_STATUSES_SEED: readonly ServiceTicketStatusDef[] = [
  {
    id: 'sts-new',
    key: 'new',
    label: 'New',
    icon: 'inbox',
    tone: 'neutral',
    isTerminal: false,
    isEnabled: true,
    isDefault: true,
    order: 0,
  },
  {
    id: 'sts-assigned',
    key: DEFAULT_SERVICE_TICKET_STATUS_KEYS.ASSIGNED,
    label: 'Assigned',
    icon: 'inbox',
    tone: 'info',
    isTerminal: false,
    isEnabled: true,
    isDefault: true,
    order: 1,
  },
  {
    id: 'sts-in-progress',
    key: DEFAULT_SERVICE_TICKET_STATUS_KEYS.IN_PROGRESS,
    label: 'In progress',
    icon: 'autorenew',
    tone: 'brand',
    isTerminal: false,
    isEnabled: true,
    isDefault: true,
    order: 2,
  },
  {
    id: 'sts-resolved',
    key: DEFAULT_SERVICE_TICKET_STATUS_KEYS.RESOLVED,
    label: 'Resolved',
    icon: 'task_alt',
    tone: 'success',
    isTerminal: true,
    isEnabled: true,
    isDefault: true,
    order: 3,
  },
  {
    id: 'sts-closed',
    key: DEFAULT_SERVICE_TICKET_STATUS_KEYS.CLOSED,
    label: 'Closed',
    icon: 'archive',
    tone: 'neutral',
    isTerminal: true,
    isEnabled: true,
    isDefault: true,
    order: 4,
  },
];
